module.exports = __webpack_public_path__ + "img/66@2x.51d5db1e.png";